export default __webpack_public_path__ + "static/media/computer-search-icon.1c915ef3.png";